import { Navigate, useSearchParams } from 'react-router-dom';
import { CasdoorSdk } from './CasdoorCallback';
import { getCookie } from '@/app/common/utils/cookieService';
import { rememberAuthReturnTo, takeAuthReturnTo } from './authReturnTo';

const Login = () => {
  const [params] = useSearchParams();
  const next = params.get('next');
  if (next) rememberAuthReturnTo(next);

  const access_token = getCookie(import.meta.env.VITE_ACCESS_TOKEN_NAME);
  const refresh_token = getCookie(import.meta.env.VITE_REFRESH_TOKEN_NAME);

  if (refresh_token && access_token) {
    return <Navigate to={takeAuthReturnTo() || '/'} replace />;
  }

  window.location.replace(CasdoorSdk.getSigninUrl());
  return null;
};

export default Login;
